import apis from '@/apis';

export default async function validateErp(rule, erps) {
  const res = await apis.validateErp(erps);
  // if (res.code !== '0') throw new Error(`erp：${erps}不合法`)
  if (!res) throw new Error('');
  if (res.ret !== '0') throw new Error(res.msg || '存在无效erp，请重新输入');
}

export async function validateErpIsRepeat(rule, erps) {
  const res = await apis.validateErp(erps);
  // if (res.code !== '0') throw new Error(`erp：${erps}不合法`)
  if (!res) throw new Error('');
  if (res.code !== '0') throw new Error('请输入有效的erp账号');
}

export function validatePin(planCode, type) {
  return async (rule, pin) => {
    const res = await apis.fetchmonetisePin({ pin, planCode, type });
    if (!res) throw new Error('');
    if (res.ret !== '0') throw new Error(res.msg);
  };
}
